import React from 'react'

interface Segmento {
  segmento_id: string
  segmento_nome: string
}

interface FiltrosClientesProps {
  segmentoSelecionado: string
  statusSelecionado: string
  segmentosDisponiveis: Segmento[]
  onSegmentoChange: (segmento: string) => void
  onStatusChange: (status: string) => void
  qualidadeSelecionada?: string
  onQualidadeChange?: (qualidade: string) => void
}

const FiltrosClientes: React.FC<FiltrosClientesProps> = ({
  segmentoSelecionado,
  statusSelecionado,
  segmentosDisponiveis,
  onSegmentoChange,
  onStatusChange,
  qualidadeSelecionada = 'todos',
  onQualidadeChange
}) => {
  const statusOptions = [
    { value: 'todos', label: '📊 Todos os Status', icon: '📊' },
    { value: 'risco_alto', label: '🚨 Risco Alto', icon: '🚨' },
    { value: 'risco_medio', label: '⚠️ Risco Médio', icon: '⚠️' },
    { value: 'saudavel', label: '✅ Saudável', icon: '✅' },
    { value: 'oportunidade', label: '🎯 Oportunidade', icon: '🎯' }
  ]

  const qualidadeOptions = [
    { value: 'todos', label: '📊 Todas as Qualidades' },
    { value: 'completo', label: '✅ Completo' },
    { value: 'intermediario', label: '⚠️ Intermediário' },
    { value: 'basico', label: '📊 Básico' },
    { value: 'suspeitos', label: '🔍 Dados Suspeitos' }
  ]

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 mb-6">
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span className="text-sm font-semibold text-gray-700">Filtros:</span>
        </div>

        {/* Filtro de Segmento */}
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Segmento:</label>
          <select
            value={segmentoSelecionado}
            onChange={(e) => onSegmentoChange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="todos">🏢 Todos os Segmentos</option>
            {segmentosDisponiveis.map(seg => (
              <option key={seg.segmento_id} value={seg.segmento_id}>
                {seg.segmento_nome}
              </option>
            ))}
          </select>
        </div>

        {/* Filtro de Status */}
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Status:</label>
          <select
            value={statusSelecionado}
            onChange={(e) => onStatusChange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            {statusOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {/* Filtro de Qualidade */}
        {onQualidadeChange && (
          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-600">Qualidade:</label>
            <select
              value={qualidadeSelecionada}
              onChange={(e) => onQualidadeChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            >
              {qualidadeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Indicador de filtros ativos */}
        {(segmentoSelecionado !== 'todos' || statusSelecionado !== 'todos' || qualidadeSelecionada !== 'todos') && (
          <button
            onClick={() => {
              onSegmentoChange('todos')
              onStatusChange('todos')
              onQualidadeChange?.('todos')
            }}
            className="ml-auto px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            Limpar Filtros
          </button>
        )}
      </div>
    </div>
  )
}

export default FiltrosClientes
